var _classCallCheck = require("/home/runner/work/welovetiszato/welovetiszato/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/welovetiszato/welovetiszato/node_modules/@babel/runtime/helpers/createClass");

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self)["tiny-lru"] = e();
}(this, function () {
  "use strict";

  var t = /*#__PURE__*/function () {
    function t() {
      var _t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, t);

      this.first = null, this.items = Object.create(null), this.last = null, this.max = _t, this.size = 0, this.ttl = e;
    }

    _createClass(t, [{
      key: "has",
      value: function has(_t2) {
        return _t2 in this.items;
      }
    }, {
      key: "clear",
      value: function clear() {
        return this.first = null, this.items = Object.create(null), this.last = null, this.size = 0, this;
      }
    }, {
      key: "delete",
      value: function _delete(_t3) {
        if (this.has(_t3)) {
          var e = this.items[_t3];
          delete this.items[_t3], this.size--, null !== e.prev && (e.prev.next = e.next), null !== e.next && (e.next.prev = e.prev), this.first === e && (this.first = e.next), this.last === e && (this.last = e.prev);
        }

        return this;
      }
    }, {
      key: "evict",
      value: function evict() {
        var _t4 = this.first;
        return delete this.items[_t4.key], this.first = _t4.next, this.first.prev = null, this.size--, this;
      }
    }, {
      key: "get",
      value: function get(_t5) {
        var e;

        if (this.has(_t5)) {
          var s = this.items[_t5];
          this.ttl > 0 && s.expiry <= new Date().getTime() ? this.delete(_t5) : (e = s.value, this.set(_t5, e, !0));
        }

        return e;
      }
    }, {
      key: "keys",
      value: function keys() {
        return Object.keys(this.items);
      }
    }, {
      key: "set",
      value: function set(_t6, e) {
        var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
        var i;

        if (s || this.has(_t6)) {
          if (i = this.items[_t6], i.value = e, !1 === s && (i.expiry = this.ttl > 0 ? new Date().getTime() + this.ttl : this.ttl), this.last !== i) {
            var _t8 = this.last,
                _e = i.next,
                _s = i.prev;
            this.first === i && (this.first = i.next), i.next = null, i.prev = this.last, _t8.next = i, null !== _s && (_s.next = _e), null !== _e && (_e.prev = _s);
          }
        } else this.max > 0 && this.size === this.max && this.evict(), i = this.items[_t6] = {
          expiry: this.ttl > 0 ? new Date().getTime() + this.ttl : this.ttl,
          key: _t6,
          prev: this.last,
          next: null,
          value: e
        }, 1 == ++this.size ? this.first = i : this.last.next = i;

        return this.last = i, this;
      }
    }]);

    return t;
  }();

  return function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (isNaN(e) || e < 0) throw new TypeError("Invalid max value");
    if (isNaN(s) || s < 0) throw new TypeError("Invalid ttl value");
    return new t(e, s);
  };
});